import React from 'react'
import { Icon } from './ChevronLeft.elements'

type Props = {
  className?: string
}

export const ChevronLeftIcon = ({ className }: Props) => (
  <Icon
    viewBox="0 0 11 18"
    aria-hidden
    focusable={false}
    role="img"
    className={className}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M10 17L2 9l8-8" stroke="currentColor" strokeWidth="2" />
  </Icon>
)
